<template>
  <CardForm
    :current-step="success === 'success' ? currentStep2 : currentStep"
    :card-id="cardId != undefined ? cardId : ''"
    :type="ccCardType != undefined ? ccCardType : ''"
    :acc="props.acc"
    :bc="props.bc"
    :rci="props.rci"
    :cpc="props.cpc"
    :mci="props.mci"
    :mc="props.mc"
    :crfn="props.crfn"
    :web-form-details="productBundlingValue"
    :biometric-card-list="biometricValue"
    :originalUrl="originalUrl"
    :errorMessage="errorMessage"
    :region="region"
    :webFormRequestId="
      props.webFormRequestId != undefined ? props.webFormRequestId : ''
    "
    :refNo="refNo"
    :isDraft="isDraft"
    :isReminder="isReminder"
    :reminderValue="reminderValue"
    :resumeWebFormRequestId="resumeWebFormRequestId"
    :token="token ? token : ''"
    :isAutoPopulate="isAutoPopulate"
    :checkBranchFlag="checkBranchFlag"
    :resumedByRecruiterId="resumedByRecruiterId"
    :resumedByRecruiterName="resumedByRecruiterName"
    :remainingTime="remainingTime"
    @next-step="stepData"
    @previous-step="stepData"
    @set-card-id="setCardId"
  >
  </CardForm>
</template>

<script setup lang="ts">
import CardForm from "./CardForm.vue";
import { ref } from "vue";
import MasterService from "@/service/restfulService/CCOnboardMasterService";

const biometricValue = history.state.biometricValue;
const refNo = history.state.refNo;
const productBundlingValue = history.state.value;
const multiChannelcc = history.state.cc ? history.state.cc : "";
const applicationType = history.state.type;
const originalUrl = history.state.url ? history.state.url : "";
const errorMessage = history.state.error ? history.state.error : [];
const region = history.state.region ? history.state.region : "";
const isReminder = history.state.isReminder ? history.state.isReminder : false;
const isDraft = history.state.isDraft ? history.state.isDraft : false;
const reminderValue = history.state.reminderValue;
const resumeWebFormRequestId = history.state.webFormRequestId
  ? history.state.webFormRequestId
  : "";
const token = history.state.token;
const isAutoPopulate = history.state.isAutoPopulate;
const resumedByRecruiterId = history.state.resumedByRecruiterId
  ? history.state.resumedByRecruiterId
  : "";
const resumedByRecruiterName = history.state.resumedByRecruiterName
  ? history.state.resumedByRecruiterName
  : "";
const remainingTime = history.state.remainingTime
  ? history.state.remainingTime
  : "";
const checkBranchFlag = ref(false);
const currentStep = ref(1);

const props = defineProps<{
  cc: string;
  type: string;
  webFormRequestId: string;
  acc: string;
  bc: string;
  rci: string;
  cpc: string;
  mci: string;
  mc: string;
  crfn: string;
}>();

const cardId = ref("");
const ccCardType = ref("");

cardId.value = multiChannelcc != "" ? multiChannelcc : props.cc;
ccCardType.value = applicationType ? applicationType : props.type;

const success = ref("success");
const currentStep2 = ref();

//CC Form
if (isAutoPopulate) {
  if ((props.cc == "NA" || props.cpc == "NA") && props.type != "BIO") {
    currentStep2.value = 0;
  } else {
    currentStep2.value = 1;
  }
} else if (isDraft) {
  // resume product bundling
  if (
    reminderValue.productBundlingExpiredtype == "PF_CC" ||
    reminderValue.productBundlingExpiredtype == "EP_CC"
  ) {
    const requestModel = {
      webFormRequestId: resumeWebFormRequestId,
      currentStep: "",
      forward: false,
      backward: false,
      resume: true,
      autoPopulated: false,
      summaryEditBtn: "",
    };
    MasterService.productFlow(requestModel)
      .then((res) => {
        if (res.status == 200) {
          currentStep2.value = Number(res.data.responseModel.stepCode);
        }
      })
      .catch((e) => {});
  } else {
    if (reminderValue.dropOffStep == "S0") currentStep2.value = 0;
    else if (reminderValue.dropOffStep == "S1" || !reminderValue.cardId)
      currentStep2.value = 1;
    else if (
      reminderValue.dropOffStep == "S3" ||
      reminderValue.dropOffStep == "S4" ||
      reminderValue.dropOffStep == "S5"
    )
      currentStep2.value = 4;
    else if (reminderValue.dropOffStep == "S6") currentStep2.value = 5;
    else if (reminderValue.dropOffStep == "S7") currentStep2.value = 6;
    else if (reminderValue.dropOffStep == "S8") currentStep2.value = 7;
    else if (reminderValue.dropOffStep == "S9") currentStep2.value = 8;
    else if (reminderValue.dropOffStep == "S10") currentStep2.value = 9;
    else if (reminderValue.dropOffStep == "S11") currentStep2.value = 11;
    else if (reminderValue.dropOffStep == "S12") currentStep2.value = 11;
    else if (reminderValue.dropOffStep == "S13") currentStep2.value = 12;
    else if (reminderValue.dropOffStep == "S98") currentStep2.value = 12;
    else if (reminderValue.dropOffStep == "P1") currentStep2.value = 1;

    if (currentStep2.value >= 7) {
      checkBranchFlag.value = true;
    }
  }
} else if (isReminder) {
  currentStep2.value = 103;
} else {
  if (applicationType == "BIO") {
    currentStep2.value = 16;
  } else if (
    applicationType == "CR_SL" ||
    applicationType == "FINPLUS" ||
    (props.cc != "" && props.cc != undefined) ||
    (props.cpc != "" && props.cpc != undefined)
  ) {
    currentStep2.value = 101;
  }
  //Product Bundling
  //TODO-Matrix
  else {
    const requestModel = {
      webFormRequestId: productBundlingValue.webFormRequestId,
      currentStep: "",
      forward: true,
      backward: false,
      resume: false,
      autoPopulated: false,
      summaryEditBtn: "",
    };
    MasterService.productFlow(requestModel)
      .then((res) => {
        if (res.status == 200) {
          currentStep2.value = res.data.responseModel.stepCode;
        }
      })
      .catch((e) => {});
  }
}

const stepData = (data: number) => {
  if (success.value == "success") {
    currentStep2.value = data;
  } else {
    currentStep.value = data;
  }
};

const setCardId = (selectedCardId: any) => {
  cardId.value = selectedCardId;
};
</script>

<style scoped></style>
